<script>
  import Rodape from '~componentes/Footer.vue';
  import VoltarAoTopo from '~componentes/VoltarAoTopo.vue';

  import Vue from 'vue';
  import VueResource from 'vue-resource';

  Vue.use(VueResource);
  
  export default {
    components: { Rodape, VoltarAoTopo },
    data() {
      return {
        urlImagem: true,
      }
    },
    methods: {
      verificarUrlImagem() {
        Vue.http.get('/img/logo-impressao.png')
          .then(() => {
            this.urlImagem = true;
          }).catch(() => {
            this.urlImagem = false;
          });
      }
    },
    mounted() {
      this.verificarUrlImagem();
    }
  }
</script>

<template>
  <div id="wrapper" class="top-navigation">
    <div id="page-wrapper" class="gray-bg">

      <div class="row border-bottom white-bg">
        <nav class="navbar navbar-static-top" role="navigation">
          <div v-if="urlImagem" class="navbar-header">
            <router-link :to="{ name: 'home' }" class="navbar-brand">
              <img src="/img/logo-impressao.png" alt="logo empresa" style="max-height: 50px;">
            </router-link>
          </div>
          <div v-else class="navbar-header">
            <router-link :to="{ name: 'home' }" class="navbar-brand">
              <img src="/img/logo-impressao-gemini.png" alt="logo gemini" style="max-height: 50px;">
            </router-link>
          </div>
        </nav>
      </div>
      
      <div class="wrapper wrapper-content no-padding-right no-padding-left">
        <div class="container center-block no-padding">
          <router-view :key="$route.path"></router-view>
        </div>
      </div>

      <rodape></rodape>

      <voltar-ao-topo></voltar-ao-topo>
    </div>
  </div>
</template>

<style>
  .navbar-header a.navbar-brand {
    background: transparent!important;
    padding: 5px 10px 0 10px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutExterno.vue